export var ASSETS_TOOLBAR = "assets";
export var TEXT_TOOLBAR = "text";
export var FRAMES_TOOLBAR = "frames";